import { ColumnHelper, HeaderContext } from "@tanstack/react-table";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { CustomValueImportRow } from "PFTypes";
import React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { ImportStatePill } from "../import_state_pill";

export const useColumnsGenerator = () => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "header.modals.import.data.table" });

  const header = useCallback(
    (header: HeaderContext<CustomValueImportRow, unknown>) => (
      <Typography variant="bodyRegular" tag="span">
        {t(`headers.${header.header.id}` as unknown as TemplateStringsArray)}
      </Typography>
    ),
    [t]
  );

  return useCallback(
    (columnHelper: ColumnHelper<CustomValueImportRow>) => [
      columnHelper.accessor((row) => row.rowValue, {
        id: "name",
        header,
        cell: (info) => info.getValue(),
        size: 250,
        enableSorting: false
      }),
      columnHelper.accessor((row) => row.state, {
        id: "state",
        header,
        cell: (info) => info.getValue() && <ImportStatePill state={info.getValue()} />,
        size: 150,
        enableSorting: false
      }),
      columnHelper.accessor(
        (row) => (row.state === "merged" ? row.customValue.lastMergedInto.value : row.customValue.text),
        {
          id: "customValue",
          header,
          cell: (info) => info.getValue(),
          size: 250,
          enableSorting: false
        }
      ),
      columnHelper.accessor((row) => row.customValue.globalId, {
        id: "global",
        header,
        cell: (info) => info.getValue() && <Icon name="check" color={"paletteGreen0"} />,
        enableSorting: false
      }),
      columnHelper.accessor((row) => row.state === "merged", {
        id: "merged",
        header,
        cell: (info) => info.getValue() && <Icon name="check" color={"paletteGreen0"} />,
        enableSorting: false
      }),
      columnHelper.accessor((row) => row.state === "blocked", {
        id: "blocked",
        header,
        cell: (info) => info.getValue() && <Icon name="cross" color={"paletteRed1"} />,
        enableSorting: false
      })
    ],
    [header]
  );
};
